 const LOCAL_URL = process.env.REACT_APP_LOCAL_URL;
export const API_URL = LOCAL_URL ? LOCAL_URL : window.location.origin + "/";
// export const API_URL = 'https://saas.uat.mykademy.com';
export const token_string = "IDPATSN";
export const API_TOKEN_PREFIX = "IDPAT";
export const CSRF_COOKIE_PREFIX = "IDPCC";
export const CSRF_HEADER_PREFIX = "IDPCH";
export const CSRF_TOKEN_PREFIX = "IDPCT";
// if (process.env.NODE_ENV == 'development') {
//   // public/testdata/
//   console.log('LOCAL_URL', process.env.NODE_ENV);
  // console.log('API_URL', API_URL);
//   var _EXT = '.json';
//   var _post_meth = 'get';
// } else {
var _post_meth = "post";
var _EXT = "";
// }
export const EXT = _EXT;
export const _post = _post_meth;
export let headers = {
  Accept: "application/json",
  "Content-Type": "application/json",
  // csrf_header: csrf_value,
};
export const reportModuleName = "reports";
export const securityModuleNAme = "security";
export const settingsModuleName = "settings";
export const userManagementModuleName = "usermanagement";
export const overviewModuleName = "overview";
export const subscriptionModuleName = "subscription";
export const accessManagementModuleName = "accessmanagement";
export const courseApprenticeshipModuleName = 'courseapprenticeship';
export const organisationModuleName = "organisation";
export const reminderModuleName             = 'reminders';
export const frontEndModuleName = "front_end";
export const bulkEnrollModuleName = "bulk_enrollment";
export const commonModuleName = "common";
export const availableLanguages = [
  { label: "EN", fullLabel : 'English', value: "en" },
  { label: "FR", fullLabel : 'French', value: "fr" },
];

export const authToken =
  "mykademy mykademy:NzN07J7INMN6N-NGN0NjNb74N.7472NQ7HNF7k7R7R7u7271NWN_7fNcNQ7_N-N.75NLN7NbN3Ns7ONo7d7QNcNXN67v7HNGNJNv7kNoNm7uNRNcNgNJNQ717RNiNe7I7Q7U6261303736653535313835323734653139373132623565366431363737343533jMNMNgNONhN0NCNCNv7ZNj79ND7Y70jWN.jTNYNLN3N_NuNONjN-7wNHjCN3jCjA7JNi7aNHjAjXNQNlNJN_NlN9joNg7tNsNoj3NfjPNYNvjMNBjTNsjw7~7tjhNfNaN8N_NPjoN_NHNhNpNCjcjoNyjhN_jLN2N9jpNYjYNpNCNLNuNO70NTN87kNeNJ7xN.Ns7~NA7lNiNiNE7UNG7H7-NPNXNQ787rNhjLjoNtjWNaNtjzNyjhjtj.N1NtjmNaNlNqNsNZNM7r7ONGjsj3jpjVN.N~NiNJNKNPj67kjTN67C737tNQNRjNj_N_Nkj3NVjpjC7JNg7aNHjMjVNONANtN3jjjNjgNw7UjNjoj3NRjqN8Nwj3NfjPjpjtNSNCj7N4N2NTNtjNjTNMNdNDjDj.j8NM7175N.jsNuNwjpNtNp7f7CNwNvNfNdjejpNY7Hja";
export const accessToken =
  "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6IjYxOCIsIm5hbWUiOiJhbGV4IiwiZW1haWxfaWQiOiJhbGV4LmFudG9ueUBteWthZGVteS5jb20iLCJtb2JpbGUiOiI3MzA2NTY5NDUzIiwidXNfbmFtZSI6ImFsZXgiLCJ1c19lbWFpbCI6ImFsZXguYW50b255QG15a2FkZW15LmNvbSIsInVzX3Bob25lIjoiNzMwNjU2OTQ1MyIsInVzX2dvb2dsZV9pZCI6IiIsInVzX2ZhY2Vib29rX2lkIjoiIiwiYWNjb3VudF9pZCI6IjIwMDAzIiwiaW5zdGl0dXRlX2lkIjoiMSJ9.YzW_I41zq8Mo5F_LUSPqNP5qaq9aN6Bbh0cGyJbMVM4";
